export default "/images/d06bbd941100bc84b25a2f08f1cc42c4.avif";